const Account = () => import('@/views/childrens/guest/AccountPerson');
const Documents = () => import('@/views/childrens/guest/DocumentsPerson');
const Guest = () => import('@/views/Guest');
const Politics = () => import('@/views/childrens/guest/PoliticsPerson');
const Publications = () => import('@/views/childrens/guest/Publications');
const Team = () => import('@/views/childrens/guest/TeamPerson');
const Timeline = () => import('@/views/childrens/guest/TimelinePerson');
const RenderPdf = () => import('@/components/ui/RenderPDF');
const RenderVideo = () => import('@/components/ui/RenderVideo');
const CalendarSuccess = () => import('@/views/CalendarSuccess');

let fromGeo = false;

export default [
	{
		path: '/guest',
		name: 'guest',
		component: Guest,
		meta: {
			title: 'Cuenta',
			layout: 'guest',
			requiresAuth: true,
			isPerson: true,
		},
		beforeEnter(to, from, next) {
			if (from.name === 'geolocation') fromGeo = true;
			next();
		},
		props: () => ({ fromGeo }),
		children: [
			{
				path: 'account',
				name: 'account-guest',
				component: Account,
				meta: {
					title: 'Mi perfil',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'team',
				name: 'team',
				component: Team,
				meta: {
					title: 'Mi perfil',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'politics',
				name: 'politics',
				component: Politics,
				meta: {
					title: 'Leer politicas',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'documents',
				name: 'documents-person',
				component: Documents,
				meta: {
					title: 'Mi perfil',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'timeline',
				name: 'timeline',
				component: Timeline,
				meta: {
					title: 'Mi perfil',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'publications',
				name: 'publications',
				component: Publications,
				meta: {
					title: 'Mis publicaciones',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'render-pdf',
				name: 'render-pdf',
				component: RenderPdf,
				props: route => ({
					publicationId: route.query.publicationId,
				}),
				meta: {
					title: 'Publicacion',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: 'render-video',
				name: 'render-video',
				component: RenderVideo,
				props: route => ({
					publicationId: route.query.publicationId,
				}),
				meta: {
					title: 'Publicacion',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
			{
				path: '/calendar/success',
				name: 'calendar-success',
				component: CalendarSuccess,
				meta: {
					title: 'Calendar success',
					layout: 'guest',
					requiresAuth: true,
					isPerson: true,
				},
			},
		],
	},
];
